"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformRecentViewsToViewers = exports.transformInteractions = exports.transformBlockViews = exports.usePageAnalyticsSummary = void 0;
var swr_1 = __importDefault(require("swr"));
var axios_1 = __importDefault(require("axios"));
var inversify_react_1 = require("inversify-react");
var luxon_1 = require("luxon");
function usePageAnalyticsSummary(pageId, timeParams) {
    var _a, _b;
    var periodStart = timeParams.periodStart, periodEnd = timeParams.periodEnd, timeZone = timeParams.timeZone;
    var apiBaseUrl = (0, inversify_react_1.useInjection)("apiBaseUrl");
    var url = new URL("".concat(apiBaseUrl, "/summary/dataset/pages/").concat(pageId));
    url.searchParams.append("timezone", timeZone);
    url.searchParams.append("periodStart", (_a = periodStart.toISO()) !== null && _a !== void 0 ? _a : "");
    url.searchParams.append("periodEnd", (_b = periodEnd.toISO()) !== null && _b !== void 0 ? _b : "");
    var data = (0, swr_1.default)([url.toString()], function (args) { return fetchAnalyticsSummary.apply(void 0, __spreadArray(__spreadArray([], __read(args), false), [timeParams], false)); }, {
        dedupingInterval: 15000,
    }).data;
    return { pageAnalyticsSummary: data };
}
exports.usePageAnalyticsSummary = usePageAnalyticsSummary;
function fetchAnalyticsSummary(url, timeParams) {
    return __awaiter(this, void 0, Promise, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, axios_1.default.get(url, {
                        withCredentials: true,
                    })];
                case 1:
                    data = (_a.sent()).data;
                    return [2, transformFromApi(data, timeParams)];
            }
        });
    });
}
function transformFromApi(_a, timeParams) {
    var blockViewDurations = _a.blockViewDurations, linkClicks = _a.linkClicks, overview = _a.overview, recentViews = _a.recentViews;
    var _b = transformRecentViewsToViewers(recentViews), viewers = _b.viewers, viewIdToViewersMap = _b.viewIdToViewersMap;
    return {
        blockViewDurations: transformBlockViews(blockViewDurations),
        interactions: transformInteractions(linkClicks),
        overview: transformOverview(overview, recentViews),
        viewers: viewers,
        activityChartData: transformActivityChartData(recentViews, timeParams, viewIdToViewersMap),
    };
}
function transformBlockViews(blockViews) {
    var totalDuration = blockViews.reduce(function (sum, current) { return sum + current.viewDuration; }, 0);
    return blockViews.map(function (_a, index) {
        var title = _a.title, viewDuration = _a.viewDuration, type = _a.type;
        return ({
            index: index,
            blockType: type,
            title: title,
            viewDuration: viewDuration,
            percentage: viewDuration / totalDuration,
        });
    });
}
exports.transformBlockViews = transformBlockViews;
function transformInteractions(linkClicks) {
    var totalInteractionCount = linkClicks.reduce(function (sum, current) { return sum + current.clicks; }, 0);
    return linkClicks.map(function (_a, index) {
        var text = _a.text, href = _a.href, clicks = _a.clicks;
        return ({
            index: index,
            target: text,
            extraDetails: href,
            type: "link",
            count: clicks,
            percentage: clicks / totalInteractionCount,
        });
    });
}
exports.transformInteractions = transformInteractions;
function transformOverview(_a, recentViews) {
    var latestViewTime = _a.latestViewTime, averageViewDuration = _a.averageViewDuration;
    var latestViewDate = new Date(latestViewTime);
    var isValidDate = Boolean(latestViewDate.getTime());
    return {
        totalViews: recentViews.length,
        mostRecentlyViewed: isValidDate ? latestViewDate : null,
        averageViewDuration: averageViewDuration,
    };
}
function transformRecentViewsToViewers(recentViews) {
    var _a;
    var viewersMap = new Map();
    var viewIdToViewersMap = new Map();
    for (var i = 0; i < recentViews.length; ++i) {
        var _b = recentViews[i], viewUserId = _b.viewUserId, email = _b.email, pageViewId = _b.pageViewId, location = _b.location, countryCode = _b.countryCode, timestamp = _b.timestamp, duration = _b.duration, fullName = _b.fullName;
        var session = transformToBasicSession(recentViews[i]);
        var _c = getViewerId({ email: email, viewUserId: viewUserId, pageViewId: pageViewId }), id = _c.id, idType = _c.idType;
        var isAnonymous = email == null;
        var firstName = (_a = fullName !== null && fullName !== void 0 ? fullName : email) !== null && _a !== void 0 ? _a : "Anonymous";
        var viewDate = new Date(timestamp);
        var existingViewer = viewersMap.get(id);
        if (existingViewer) {
            existingViewer.sessions.unshift(session);
            existingViewer.totalViewDuration += duration;
            if (viewDate.getTime() > existingViewer.mostRecentView.getTime()) {
                existingViewer.mostRecentView = viewDate;
                existingViewer.location = location;
            }
            viewIdToViewersMap.set(pageViewId, existingViewer);
        }
        else {
            var newViewer = {
                id: id,
                idType: idType,
                isAnonymous: isAnonymous,
                email: email !== null && email !== void 0 ? email : undefined,
                firstName: firstName,
                mostRecentView: viewDate,
                sessions: [session],
                totalViewDuration: duration,
                location: location,
                countryCode: countryCode,
            };
            viewersMap.set(id, newViewer);
            viewIdToViewersMap.set(pageViewId, newViewer);
        }
    }
    var viewers = Array.from(viewersMap.values()).sort(function (a, b) { return b.mostRecentView.getTime() - a.mostRecentView.getTime(); });
    return { viewers: viewers, viewIdToViewersMap: viewIdToViewersMap };
}
exports.transformRecentViewsToViewers = transformRecentViewsToViewers;
function getViewerId(_a) {
    var email = _a.email, viewUserId = _a.viewUserId, pageViewId = _a.pageViewId;
    if (email)
        return { id: email, idType: "email" };
    if (viewUserId)
        return { id: viewUserId, idType: "viewUserId" };
    return { id: pageViewId, idType: "pageViewId" };
}
function transformToBasicSession(_a) {
    var email = _a.email, duration = _a.duration, pageViewId = _a.pageViewId, location = _a.location, countryCode = _a.countryCode, device = _a.device, ip = _a.ip, browser = _a.browser, timestamp = _a.timestamp;
    return {
        email: email,
        duration: duration,
        pageViewId: pageViewId,
        location: location,
        countryCode: countryCode,
        device: device,
        ip: ip,
        browser: browser,
        timestamp: new Date(timestamp),
    };
}
function transformActivityChartData(recentViews, _a, viewIdToViewersMap) {
    var _b, _c;
    var periodStart = _a.periodStart, periodEnd = _a.periodEnd, timeUnit = _a.timeUnit;
    var chartData = [];
    var numBuckets = Math.trunc(periodEnd.diff(periodStart).as(timeUnit));
    var ascendingViews = recentViews.slice().reverse();
    var ascendingViewsPointer = ascendingViews.findIndex(function (v) { return luxon_1.DateTime.fromISO(v.timestamp) >= periodStart; });
    for (var i = 0; i < numBuckets; ++i) {
        var bucketTime = periodStart.plus((_b = {}, _b[timeUnit] = i, _b));
        var bucketInterval = luxon_1.Interval.fromDateTimes(bucketTime, bucketTime.plus((_c = {}, _c[timeUnit] = 1, _c)));
        var recentViewsInBucket = [];
        if (ascendingViews.length > 0) {
            while (ascendingViewsPointer < ascendingViews.length) {
                var view = ascendingViews[ascendingViewsPointer];
                if (bucketInterval.contains(luxon_1.DateTime.fromISO(view.timestamp))) {
                    recentViewsInBucket.push(view);
                    ++ascendingViewsPointer;
                }
                else {
                    break;
                }
            }
        }
        chartData.push({
            epochTime: bucketTime.toMillis(),
            viewCount: recentViewsInBucket.length,
            views: recentViewsInBucket.map(function (recentView) {
                var viewer = viewIdToViewersMap.get(recentView.pageViewId);
                if (viewer == undefined) {
                    throw new Error("Error building data for the Activity chart: could not find the viewer associated with ".concat(recentView.pageViewId));
                }
                var session = viewer.sessions.find(function (s) { return s.pageViewId === recentView.pageViewId; });
                if (session == undefined) {
                    throw new Error("Error building data for the Activity chart: could not find the session associated with ".concat(recentView.pageViewId));
                }
                return {
                    viewer: viewer,
                    session: session,
                };
            }),
            luxonDateTime: bucketTime,
        });
    }
    return chartData;
}
